/* eslint-disable jira/filename-case */

import type { CookieCircuitBreakerConfig } from '@jira/platform__routing-route-types/src/JiraSpaRoute.tsx';
import { getCookieCircuitBreaker } from './get-cookie-circuit-breaker.tsx';

export function isCircuitOpen(config?: CookieCircuitBreakerConfig): boolean {
	// circuit will never be open if isSetCookieEnabled is false
	if (config?.isSetCookieEnabled) {
		const circuitBreaker = getCookieCircuitBreaker(config);
		return circuitBreaker?.getState().state === 'OPEN';
	}
	return false;
}
